import { Routes } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { HomeComponent } from './home/home.component';
import { RoleGuard } from './role.guard';
import { roles } from './auth-config';
import { LoginComponent } from './login/login.component';
import { ItemsComponent } from './items/items.component';
import { SuppliersComponent } from './suppliers/suppliers.component';
import { ItemsUploadComponent } from './items-upload/items-upload.component';
import { ParkingLotComponent } from './parking-lot/parking-lot.component';
import { AiSearchComponent } from './ai-search/ai-search.component';
import { ForcePublishComponent } from './batch-operations/force-publish.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { ApimSubscriptionsComponent } from './apim-subscriptions/apim-subscriptions.component';
import { AllowedSupplierComponent } from './allowed-supplier/allowed-supplier.component';
import { SourcesComponent } from './sources/sources.component';
import { SupplierLookupComponent } from './supplier-lookup/supplier-lookup.component';
import { ForcePublishReceiversComponent } from './force-publish-receivers/force-publish-receivers.component';
import { SystemLanguageCodesComponent } from './system-language-codes/system-language-codes.component';
import { BatchConsumersComponent } from './batch-consumers/batch-consumers.component';

export const routes: Routes = [
    {
        // Needed for handling redirect after login
        path: 'auth',
        component: MsalRedirectComponent
    },
    {
        path: '',
        component: HomeComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin, roles.AdminToolReader, roles.AdminToolWrite] }
    },
    {
        path: 'items',
        component: ItemsComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin, roles.AdminToolReader, roles.AdminToolWrite] }
    },
    {
        path: 'suppliers',
        component: SuppliersComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin, roles.AdminToolReader, roles.AdminToolWrite] }
    },
    {
        path: 'upload-items',
        component: ItemsUploadComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'parking-lot',
        component: ParkingLotComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin, roles.AdminToolReader, roles.AdminToolWrite] }
    },
    {
        path: 'ai-search',
        component: AiSearchComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AISearch] }
    },
    {
        path: 'force-publish',
        component: ForcePublishComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'audit-log',
        component: AuditLogComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'apim-subscriptions',
        component: ApimSubscriptionsComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'allowed-suppliers',
        component: AllowedSupplierComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'sources',
        component: SourcesComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'supplier-lookup',
        component: SupplierLookupComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'force-publish-receivers',
        component: ForcePublishReceiversComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'system-language-codes',
        component: SystemLanguageCodesComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'batch-consumers',
        component: BatchConsumersComponent,
        canActivate: [RoleGuard],
        data: { expectedRoles: [roles.AdminToolAdmin] }
    },
    {
        path: 'login',
        component: LoginComponent
    }    
];

export const initialNavigation = !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup();
